import React from "react";
import * as Comp from "../../../../components";

interface OwnProps {
    formComponent: Comp.Validation.IComponentWithValidatedForm;
    label?: string;
    namePrefix: string;
}

interface OwnState {
}

export class ContentHeroEditor extends React.Component<OwnProps, OwnState> {
    public render() {
        const label = this.props.label
            ? <Comp.Editors.FormField name=""><hr /><h2>{this.props.label}</h2></Comp.Editors.FormField>
            : null;

        return <div className="content-block-editor">
            {label}

            <Comp.Editors.TextField
                formComponent={this.props.formComponent}
                name={this.props.namePrefix + "image"}
            />

            <Comp.Editors.RichTextField
                formComponent={this.props.formComponent}
                isAdmin
                name={this.props.namePrefix + "body"}
                options={{
                    height: 250,
                    width: "59.8%",
                }}
            />
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminPage/edit/editors/ContentHeroEditor.tsx